import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Flex, Heading, Text } from '@chakra-ui/react'

import { ImageWrapper } from 'components/partials/cart/CartItem/styles'
import { StaticComplementaryItems } from 'components/partials/cartAndPayment/StaticComplementaryItems'
import { OrderItemHeader } from 'components/partials/shared/OrderItemHeader'
import { selectOrderState } from 'store/partials/cart/cartSelectors'
import { getCart } from 'store/partials/cart/cartSlice'
import { removeDecimals } from 'utils/removeDecimals'
import { separateOrderItemsFromModule } from 'utils/seperateOrderItems'

import { StyledCartPreview } from './styles'

export const CartPreview = (): JSX.Element => {
  const { t } = useTranslation(['common', 'cart'])
  const dispatch = useDispatch()
  const { cart } = useSelector(selectOrderState)

  useEffect(() => {
    const orderId = Number(localStorage.getItem('orderId'))

    if (cart === null && orderId) {
      dispatch(getCart(orderId))
    }
  }, [])

  const { ordinaryItemsInfo, complementaryItemsInfo } = separateOrderItemsFromModule(cart?.orderItems)

  return (
    <StyledCartPreview>
      <Heading as="h3" fontSize="lg" fontWeight={400} textAlign="left" lineHeight={{ base: 1.33, md: 1.2 }}>
        {t('cart')}
      </Heading>

      {!cart || cart?.orderItems.length === 0 ? (
        <Flex direction="column" justifyContent="center" alignItems="center" height="100%">
          <img src="/icons/cart-preview.svg" />
          <Text fontSize="sm" color="black" fontWeight={500} marginTop="30px">
            {t('emptyCartHeading')}
          </Text>
          <Text color="gray.a500" fontSize="xs" fontWeight={300}>
            {t('emptyCartCopy')}
          </Text>
        </Flex>
      ) : (
        <>
          {ordinaryItemsInfo?.map((info) => (
            <Flex key={`${info.orderItem.id}-${Math.random()}`} textAlign="left" direction="column" marginTop="15px">
              {info.orderItem.productData?.products && info.orderItem.productData.products.length > 1 ? (
                <>
                  <OrderItemHeader
                    name={`${info.orderItem.productData?.name}`}
                    rentedFrom={info.orderItem.rentedFrom}
                    rentedTo={info.orderItem.rentedTo}
                    location={info.location?.name}
                  />

                  <Text marginBottom="12px" fontSize="xs">
                    {t('cart:includes')}
                  </Text>

                  {info.orderItem.productData?.products?.map((product) => (
                    <Flex marginBottom="15px" key={product.id}>
                      <ImageWrapper>
                        <img src={product.imageUrl || ''} alt="" />
                      </ImageWrapper>
                      <Box marginLeft="20px">
                        <Text color="black" fontSize="xs" fontWeight={600}>
                          {product.name}
                        </Text>
                      </Box>
                    </Flex>
                  ))}

                  <Text color="black" fontSize="xs" fontWeight={400} marginLeft="120px">
                    {t('rentalPrice')} {removeDecimals(info.orderItem.price)} {t('nok')}
                  </Text>
                </>
              ) : (
                info.orderItem.productData?.products?.map((product) => (
                  <Flex marginBottom="15px" key={product.id}>
                    <ImageWrapper>
                      <img src={product.imageUrl || ''} alt="" />
                    </ImageWrapper>
                    <Box marginLeft="20px">
                      <OrderItemHeader
                        name={product.name}
                        rentedFrom={info.orderItem.rentedFrom}
                        rentedTo={info.orderItem.rentedTo}
                        location={info.location?.name}
                      />

                      <Text color="black" fontSize="xs" fontWeight={400}>
                        {t('rentalPrice')}: {removeDecimals(info.orderItem.price)} {t('nok')}
                      </Text>
                    </Box>
                  </Flex>
                ))
              )}
            </Flex>
          ))}
          {complementaryItemsInfo && !!complementaryItemsInfo.length && (
            <StaticComplementaryItems complementaryItemsInfo={complementaryItemsInfo} />
          )}
        </>
      )}
    </StyledCartPreview>
  )
}
